import styled from '@emotion/styled';

const CreateContentWrapper = styled('section')(({ theme }) => ({
  marginTop: 48,
  marginBottom: 72,
  marginLeft: 'auto',
  marginRight: 'auto',
  width: 490,
  maxWidth: '100%',
  h1: {
    fontSize: 28,
    fontWeight: 500,
    '.MuiSvgIcon-root': {
      marginRight: 12,
      color: theme.palette.text.secondary,
    },
  },
  p: {
    marginBottom: 18,
    color: theme.palette.text.secondary,
  },
}));

export default CreateContentWrapper;
